import { FloatingPosition, Tooltip } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import s from './MultiLineEllipsis.module.scss';

type MultiLineEllipsisProps = {
  className?: string;
  children: React.ReactNode;
  maxLine?: number;
  position?: FloatingPosition;
  maw?: number;
};

const MultiLineEllipsis: React.FC<MultiLineEllipsisProps> = ({ className, children, maxLine, position, maw = 300 }) => {
  const ref = React.useRef<HTMLSpanElement | null>(null);
  const [isEllipsis, setIsEllipsis] = React.useState(false);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    const check = () => {
      if (!ref.current) {
        return;
      }

      setIsEllipsis(ref.current.scrollHeight - 1 > ref.current.clientHeight);
    };

    const resizeObserver = new ResizeObserver(check);

    resizeObserver.observe(ref.current);
    check();

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  if (children === null) {
    return null;
  }

  return (
    <Tooltip
      disabled={!isEllipsis}
      label={children}
      position={position}
      maw={maw}
      inline
      withArrow
      withinPortal={false}
      multiline
      events={{ hover: true, focus: false, touch: true }}
    >
      <span ref={ref} style={{ '--max-line': maxLine } as React.CSSProperties} className={cn(s.root, className)}>
        {children}
      </span>
    </Tooltip>
  );
};

export default MultiLineEllipsis;
